import {Container, Nav, Navbar} from "react-bootstrap";
import {Outlet, useNavigate} from "react-router-dom";
import * as React from "react";
import rootStore from "../stores/rootStore.js";
import {observer} from "mobx-react";
import Button from "react-bootstrap/Button";
import {useState} from "react";
import AdminNav from "./AdminNav.jsx";
import CustomerNav from "./CustomerNav.jsx";
import MuniNav from "./MuniNav.jsx";
import bctcLogo from "../images/BCTC_Logo_Horiz_small.png";

function Layout() {
    const nav = useNavigate();
    var authStore = rootStore.authenticationStore;
    const auth = authStore.authentication;
    const [sidebarExpanded, setSidebarExpanded] = useState(true);
    const toggleSidebar = () => setSidebarExpanded(prev => !prev);
    return (
        authStore.signedIn() ? (
            <>
                <Navbar className="bg-body-tertiary" expand="lg">
                    <Container fluid>
                        <div className="d-flex align-items-center gap-3">
                            <Navbar.Brand href="/">
                                <img
                                    src={bctcLogo}
                                    height="40"
                                    className="d-inline-block align-top"
                                    alt="BCTC logo"
                                />
                            </Navbar.Brand>
                            <Nav className="me-auto">
                                <Nav.Link href="/">Dashboard</Nav.Link>
                            </Nav>
                        </div>

                        <Navbar.Text className="ms-auto">
                            {authStore.signedIn() ? (
                                <>
                                    <div>
                                        <i style={{fontSize: 20}} className="bi bi-person-fill"></i><a href="/account">{authStore.authentication.firstName + ' ' + authStore.authentication.lastName}</a> |
                                        &nbsp;<a href="#" onClick={() => authStore.logout()}>Logout</a>
                                    </div>
                                    <div style={{fontSize:11, marginLeft:20}}>{authStore.authentication.orgName}</div>
                                </>
                            ) : (
                                <a href="/login">Login</a>
                            )}
                        </Navbar.Text>
                    </Container>
                </Navbar>
                <div className="app-shell">
                    <div className={`sidebar ${sidebarExpanded ? "expanded" : "collapsed"}`}>
                        <button className="sidebar-toggle" onClick={toggleSidebar} aria-label="Toggle navigation">
                            <i className={`bi ${sidebarExpanded ? "bi-chevron-left" : "bi-chevron-right"}`}></i>
                        </button>
                        <div className="sidebar-inner">
                            {auth.orgType === 'AdminOrg' && <AdminNav compact={!sidebarExpanded} />}
                            {auth.orgType === '' && <CustomerNav compact={!sidebarExpanded} />}
                            {auth.orgType === 'TaxAuthority' && <MuniNav compact={!sidebarExpanded} />}
                        </div>
                    </div>
                    <div className="app-content">
                        <Outlet />
                    </div>
                </div>
            </>
        ) : (
            <Outlet />
        )
    );
}

export default observer(Layout);
